export default __webpack_public_path__ + "static/media/R5C_8167.912614fb.jpg";